import React, { useEffect, useState } from "react";
import { Check, ArrowUpRight, Clock } from "lucide-react";
import { RATES, OPEN_PLAY, PEAK_HOURS, BOOKING_URL } from "../../mock/mock";
import { fetchPublic } from "../adminApi";
import D2Banner from "../D2Banner";
import { Reveal, SplitWords } from "../motionHelpers";

export default function RatesPage2() {
  const [rates, setRates] = useState(RATES);
  useEffect(() => {
    fetchPublic("rates").then((d) => { if (d && d.length) setRates(d); }).catch(() => {});
  }, []);
  return (
    <div>
      <D2Banner eyebrow="Simple Pricing" title="Rates & Fees" subtitle="Book by the hour, drop in for open play, or go all-in with a membership." crumbs={[{ label: "Rates and Fees" }]} />

      <section className="d2-bg py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {rates.map((r, i) => (
              <Reveal key={r.id || r.name} delay={i * 0.08}>
                <div data-hover className={`d2-card h-full flex flex-col p-8 rounded-2xl border-2 ${r.highlight ? "bg-sc-lime border-sc-lime" : "bg-[#0b241a] border-white/10"}`}>
                  {r.highlight && <span className="font-grotesk uppercase text-[11px] tracking-widest bg-[#06170f] text-sc-lime px-3 py-1 w-fit mb-4">Popular</span>}
                  <h3 className={`font-grotesk font-bold uppercase text-lg ${r.highlight ? "text-sc-green" : "text-sc-lime"}`}>{r.name}</h3>
                  <div className="mt-3 flex items-end gap-1">
                    <span className={`font-display text-5xl ${r.highlight ? "text-[#06170f]" : "text-white"}`}>{r.price}</span>
                    <span className={`font-mono2 text-sm mb-2 ${r.highlight ? "text-[#06170f]/70" : "text-white/50"}`}>{r.unit}</span>
                  </div>
                  <ul className="mt-6 space-y-3 flex-1">
                    {r.features.map((f) => (
                      <li key={f} className={`flex items-start gap-2 text-sm ${r.highlight ? "text-[#06170f]/85" : "text-white/70"}`}>
                        <Check className={`w-4 h-4 mt-0.5 shrink-0 ${r.highlight ? "text-sc-green" : "text-sc-lime"}`} />{f}
                      </li>
                    ))}
                  </ul>
                  <a href={BOOKING_URL} className={`mt-7 inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-bold ${r.highlight ? "btn-green" : "d2-btn"}`}>{r.cta}<ArrowUpRight className="w-4 h-4" /></a>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal>
            <div className="mt-8 bg-[#0b241a] border border-white/10 rounded-2xl p-6 md:p-8">
              <div className="flex items-center gap-3 mb-5">
                <Clock className="w-5 h-5 text-sc-lime" />
                <h3 className="font-display uppercase text-2xl text-white">Peak Hours</h3>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="font-mono2 uppercase text-[11px] tracking-widest text-white/40">
                      <th className="py-2 pr-4 font-normal"></th>
                      <th className="py-2 pr-4 font-normal">Pickleball Court</th>
                      <th className="py-2 font-normal">Padel Court</th>
                    </tr>
                  </thead>
                  <tbody className="font-grotesk">
                    {PEAK_HOURS.map((p) => (
                      <tr key={p.day} className="border-t border-white/10">
                        <td className="py-3 pr-4 text-sc-lime font-bold whitespace-nowrap">{p.day}</td>
                        <td className="py-3 pr-4 text-white/80">{p.pickleball}</td>
                        <td className="py-3 text-white/80">{p.padel}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="font-grotesk text-white/40 text-sm mt-4">All hours outside these windows are charged at the off-peak rate.</p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-sc-cream py-24">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <h2 className="font-display uppercase text-sc-green text-4xl md:text-6xl leading-[0.92]">
              <SplitWords text="Rated Open Play" className="block" />
              <SplitWords text="every single day" className="block text-sc-orange" delay={0.12} />
            </h2>
            <p className="text-gray-600 mt-5 text-lg font-grotesk">All of our open play sessions are DUPR-logged. Show up, get matched by rating, and watch your number climb.</p>
            <a href={BOOKING_URL} className="btn-green inline-flex items-center gap-3 px-8 py-4 mt-8 text-sm font-bold">Reserve a Court <ArrowUpRight className="w-4 h-4" /></a>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="bg-sc-green p-10 rounded-2xl">
              <h3 className="font-display uppercase text-3xl text-sc-lime mb-6">{OPEN_PLAY.title}</h3>
              <ul className="space-y-2">
                {OPEN_PLAY.slots.map((s) => (
                  <li key={s.day} className="flex items-center justify-between border-b border-white/15 pb-2 font-mono2 uppercase text-sc-cream text-sm">
                    <span className="font-bold">{s.day}</span><span>{s.time}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
